import { FC, Dispatch, SetStateAction } from 'react';

import { CalendarIcon, DownArrowIcon } from '@assets/icons';
import CustomIcon from '@components/utils/CustomIcon';
import ShopAndFlySearchBarInput from '@domain/tour/searchBar/searchMonthDate/SearchBarInput';

import SearchBarInput from '../SearchBarInput/SearchBarInput';
import SearchMonthList from './components/SearchMonthList';
import { YearTabProps } from './interface';
import { SearchPopoverWrapper } from './styled';

interface Props {
  currentYearTab: YearTabProps;
  setCurrentYearTab: Dispatch<SetStateAction<YearTabProps>>;
  nextYearTab: YearTabProps;
  setNextYearTab: Dispatch<SetStateAction<YearTabProps>>;
  selectedMonthsLabel?: string;
  inputComponent: 'shopAndFly' | 'setur';
}

type InputComponentsType = 'shopAndFly' | 'setur';

const InputComponents = {
  shopAndFly: ShopAndFlySearchBarInput,
  setur: SearchBarInput,
};

const DesktopSearchMonth: FC<Props> = ({
  setCurrentYearTab,
  setNextYearTab,
  selectedMonthsLabel,
  currentYearTab,
  nextYearTab,
  inputComponent,
}) => {
  const InputComponent = InputComponents[inputComponent as InputComponentsType];
  return (
    <SearchPopoverWrapper>
      <InputComponent
        label='Ne Zaman Gitmek İstersiniz?'
        InputComponent={
          <span>
            {selectedMonthsLabel ? selectedMonthsLabel : 'Tarih Seçimi'}
          </span>
        }
        leftIcon={() => (
          <CustomIcon
            fontSize={28}
            paletteColor='primaryBrand'
            icon={CalendarIcon}
          />
        )}
        rightIcon={() => (
          <CustomIcon
            icon={DownArrowIcon}
            fontSize={16}
            paletteColor='darkGray'
          />
        )}
        popoverProps={{
          align: 'end',
        }}
        isFilled={Boolean(selectedMonthsLabel)}
        renderOverlayContent={() => {
          return (
            <SearchMonthList
              currentYearTab={currentYearTab}
              nextYearTab={nextYearTab}
              setCurrentYearTab={setCurrentYearTab}
              setNextYearTab={setNextYearTab}
              inputComponent={inputComponent}
            />
          );
        }}
      />
    </SearchPopoverWrapper>
  );
};

export default DesktopSearchMonth;
